import type { DetailedSummaryV2ItemProps } from '@pages/Consumption/context/types'

export const setInitialValues = (data: DetailedSummaryV2ItemProps) => {
  return {
    categoryKey: data.categoryKey,
    totalValue: data.adjustment != null ? data.adjustment.toFixed(2) : '',
    observations: data.observations ?? ''
  }
}
